import { call, put, takeLatest } from 'redux-saga/effects';

import { actions } from '../../utils/constants';
import { fetchUserData, goLogout, postLogin, withRetry } from '../../utils/common-functions';
import history from '../../history';
import routes from '../../utils/routes';
import CredentialsHelper from '../../utils/credentials-helper';

function* doLogout() {
    CredentialsHelper.clear();
    yield put({ type: actions.APP_LOGOUT });
    yield call(goLogout);
}

function* tokenFromCode({ payload : { code } }) {
    try {
        const { data: loginInfo } = yield call(postLogin, {
            grant_type: 'authorization_code',
            code,
            redirect_uri: window.location.origin + '/',
        });
        yield call(CredentialsHelper.update, loginInfo.access_token, loginInfo.refresh_token);
        yield call(history.push, routes.HOME);
    } catch (e) {
        yield call(doLogout);
    }
}

export function* userInformation() {
    try {
        const userInfoRespose = yield call(withRetry(fetchUserData));
        yield put({ type: actions.USER_INFO_FETCHED, payload: userInfoRespose.data });
    } catch (e) {
        yield put({ type: actions.REQUEST_ERROR, payload: { message: 'Seu perfil não pôde ser carregado. Tente recarregar a página' } });
    }
}

export default function* login() {
    yield takeLatest(actions.LOGOUT_DO, doLogout);
    yield takeLatest(actions.LOGIN_FROM_CODE, tokenFromCode);
}



// WEBPACK FOOTER //
// ./src/components/login/login.saga.js